var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex h-100"},[_c('router-view',{attrs:{"layout-props":_vm.layoutProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }